const setCart = (state, payload) => {
    state.cart = payload;
};
const setCheckout = (state, payload) => {
    state.checkout = payload;
};
export default {
    setCart,
    setCheckout,
};